import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
    state: () => ({
        is_initialized: false,
        id: '' as string,
        email: '' as string,
        name: '' as string,
        avatar: '' as string,
        permissions: [] as UserPermission[],
        hasApiToken: false,
        theme: '' as string,
    }),
    actions: {
        setUser(user: SelfUser) {
            this.id = user.id
            this.email = user.email ?? ''
            this.name = user.name ?? ''
            this.avatar = user.avatar ?? ''
            this.hasApiToken = user.hasApiToken
            this.permissions = user.permissions ?? []
            this.theme = user.theme ?? ''
            this.is_initialized = true
        },
        isLoggedIn() {
            return this.id !== ''
        },
        isAdmin() {
            return this.permissions.includes(UserPermission.admin)
        },

        // Fetch user from server
        async fetchUser() {
            const result = await $fetch<ApiResponse<SelfUser>>('/api/users/get-self', {
                method: 'GET',
                // $fetch doesn't carry the browser's session cookie during SSR.
                headers: import.meta.server ? useRequestHeaders(['cookie']) : undefined,
            })
            if (!result.success) throw new Error(result.message)
            this.setUser(result.data)
        },
    },
})
